export const feedback = {
  title: "Plaintes et Suggestions",
  subtitle: "Protocole de Collecte et de Gestion des Plaintes des Familles",
  protocol: {
    title: "Protocole de Gestion de la Communication et des Plaintes des Familles",
    purpose: {
      title: "Objectif et Philosophie",
      points: [
        "Établir un canal clair, organisé et efficace pour que les familles puissent exprimer leurs préoccupations, suggestions ou plaintes.",
        "Garantir que toutes les communications soient écoutées et traitées avec l'attention et le respect dus.",
        "Protéger et soutenir l'équipe d'accompagnants, en agissant comme filtre et facilitateur dans la gestion des plaintes.",
        "Favoriser un environnement de confiance, de respect et d'amélioration continue dans la communauté éducative."
      ]
    },
    scope: {
      title: "Application",
      description: "Ce protocole s'applique à toutes les communications formelles de plainte ou de préoccupation présentées par les familles des élèves de l'école. Il est également valable pour recueillir des propositions d'amélioration."
    }
  },
  contact: {
    title: "Canal Unique de Réception",
    email: {
      title: "Communication par Email",
      description: "Toutes les plaintes ou préoccupations des familles devront être adressées exclusivement au Directeur."
    },
    appointment: {
      title: "Rendez-vous Préalable avec la Direction",
      description: "Pour les cas qui nécessitent une conversation en présentiel, ils seront toujours pris en charge avec un rendez-vous préalable convenu par email.",
      note: "Les familles seront informées de ce protocole et du canal unique pour assurer son utilisation correcte."
    }
  },
  process: {
    title: "Processus de Gestion de la Plainte",
    phases: [
      {
        title: "Phase 1: Réception et Filtre Initial par la Direction",
        description: "Le Directeur reçoit la plainte par le canal établi et effectue une analyse initiale.",
        steps: [
          "Dans un délai maximum de 48 heures ouvrables, un accusé de réception sera envoyé à la famille.",
          "Le Directeur effectuera une lecture et une analyse détaillée de la plainte.",
          "La clarté, la pertinence, la gravité/urgence, la compétence et le contexte seront évalués.",
          "Objectif du filtre: Protéger l'équipe des plaintes non fondées et prioriser les importantes."
        ]
      },
      {
        title: "Phase 2: Décision et Orientation par la Direction",
        description: "Basé sur l'analyse initiale, le Directeur décidera de l'action à suivre:",
        steps: [
          "Résolution Directe par la Direction: Pour les plaintes mineures ou les malentendus simples.",
          "Orientation vers l'Équipe (Filtrée et Gérée): Pour les plaintes nécessitant l'intervention du personnel.",
          "Enquête ou réunion avec les deux parties: Pour les plaintes graves ou complexes.",
          "Plainte Non Traitable: Si la plainte est non fondée ou sort de la compétence."
        ]
      },
      {
        title: "Phase 3: Suivi et Clôture",
        description: "Le Directeur supervise l'évolution et communique la résolution à la famille.",
        steps: [
          "Coordination et suivi interne des actions convenues.",
          "Communication à la famille de la résolution ou des mesures adoptées.",
          "On cherchera une clôture satisfaisante pour toutes les parties quand c'est possible."
        ]
      }
    ]
  },
  guarantees: {
    title: "Confidentialité et Respect",
    points: [
      "Toutes les informations liées aux plaintes seront traitées avec la plus grande confidentialité.",
      "Un environnement respectueux sera promu dans toutes les communications.",
      "Un registre interne sera maintenu pour identifier les modèles et les domaines d'amélioration.",
      "Ce protocole sera révisé annuellement pour assurer son efficacité."
    ]
  }
};